export default __webpack_public_path__ + "static/media/figuremap22.616a3d5c.png";